import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card"
import { Switch } from "@/components/ui/switch"
import { Rocket } from "lucide-react"
import { useState, useEffect } from "react"
import { getAllAPISessions, apiToDisplaySession, type APISession } from "@/types/session"
import type { ConfigComponentProps } from '../ConfigForm'

export function ModeSettings({ config, onUpdate, isLoading }: ConfigComponentProps) {
  const [monitoringSessions, setMonitoringSessions] = useState<{ [sessionCode: string]: boolean }>(
    config?.monitoring_sessions || {}
  )
  
  const availableSessions = getAllAPISessions()

  // Update parent when local state changes
  useEffect(() => {
    onUpdate({
      monitoring_sessions: monitoringSessions
    })
  }, [monitoringSessions, onUpdate])

  // Update local state when config changes (workspace switch)
  useEffect(() => {
    setMonitoringSessions(config?.monitoring_sessions || {})
  }, [config?.monitoring_sessions])
  
  const handleSessionToggle = (sessionCode: APISession, enabled: boolean) => {
    const updatedSessions = {
      ...monitoringSessions,
      [sessionCode]: enabled
    }
    setMonitoringSessions(updatedSessions)
  }
  
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Rocket className="h-5 w-5 text-blue-500"/>
            Bill Monitoring
          </CardTitle>
          <CardDescription>
            Enable the system to automatically evaluate bills for monitoring by session
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-4">
            <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Session Monitoring Configuration
            </div>
            {availableSessions.map((sessionCode) => (
              <div key={sessionCode} className="flex items-center space-x-2">
                <Switch
                  id={`monitoring-switch-${sessionCode}`}
                  checked={monitoringSessions[sessionCode] || false}
                  onCheckedChange={(checked) => handleSessionToggle(sessionCode, checked)}
                  disabled={isLoading}
                  aria-labelledby={`monitoring-switch-label-${sessionCode}`}
                />
                <label
                  htmlFor={`monitoring-switch-${sessionCode}`}
                  id={`monitoring-switch-label-${sessionCode}`}
                  className="text-sm font-medium leading-none cursor-pointer"
                >
                  {apiToDisplaySession(sessionCode)}
                </label>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}